import { render, staticRenderFns } from "./AppFooter.vue?vue&type=template&id=ceb2f75c&"
import script from "./AppFooter.vue?vue&type=script&lang=js&"
export * from "./AppFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ceb2f75c')) {
      api.createRecord('ceb2f75c', component.options)
    } else {
      api.reload('ceb2f75c', component.options)
    }
    module.hot.accept("./AppFooter.vue?vue&type=template&id=ceb2f75c&", function () {
      api.rerender('ceb2f75c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/@core/layouts/components/AppFooter.vue"
export default component.exports